import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/toPromise';

import { boostrapConfig } from '../config';

@Injectable()
export class AppConfigProvider {

  constructor(private httpClient: HttpClient) { }

 getSettings(): Promise<any> {
    console.log(`getSettings:: before http.get call`);

    const promise = this.httpClient.get('http://localhost:3131/?client=cuyahoga&appid=89')
      .toPromise()
      .then(settings => {
        console.log(`settings: `, settings, boostrapConfig);

        return settings;
      });

    return promise;
  }
}


// WEBPACK FOOTER //
// ./src/config/provider.ts